import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';

import { isMaxPhone } from 'chairisher/util/mediaquery';

/**
 * View which handles fetching reviews from the server and injecting them into the DOM
 */
class ReviewsView {
    /**
     * @param {Object} config
     * @param {number} config.maxOffset
     * @param {Object.<string, int>} config.pageSizes
     * @param {string} config.reviewsUrl
     */
    constructor({ maxOffset, pageSizes, reviewsUrl }) {
        /**
         * Max number of times reviews can be fetched from the server.
         */
        this.maxOffset = maxOffset;

        /**
         * Number of times reviews have been fetched from the server.
         */
        this.offset = 0;

        /**
         * Number of reviews per page.
         */
        this.pageSizes = pageSizes;

        /**
         * URL to hit to fetch reviews.
         */
        this.reviewsUrl = reviewsUrl;

        /**
         * Markup for a single review.
         *
         * @type {string}
         */
        this.reviewTemplateMarkup = $('#js-review-template').html();

        /**
         * @type {jQuery}
         */
        this.$reviewsList = $('.js-reviews-list');
    }

    /**
     * Create review fragments, inject them into the DOM and lay them out prettily.
     *
     * @param reviews {Array.<Object.<string, string>>} Array of review objects.
     */
    processReviews(reviews) {
        const $temp = $('<div></div>');

        reviews.forEach((review) => {
            const $review = $(this.reviewTemplateMarkup);
            $review.find('.js-content').text(review.content);
            $review.find('.js-name').text(review.name);
            $review.find('.js-location').text(review.location);
            $review.find('.js-date').text(review.date);
            $review.find('.js-rating-active').css('width', `${review.rating_pct}%`);
            if (review.rating !== null) {
                const $rating = $review.find('.js-rating');
                $rating.attr({
                    'aria-label': `${review.rating} out of 5 stars`,
                    'role': 'img',
                });
            }
            $temp.append($review);
        });

        const items = $($temp.html());
        this.$reviewsList.append(items);
        this.offset += 1;
    }

    /**
     * Whether the view has exceeded its max number of fetches.
     *
     * @returns {boolean}
     */
    canFetchReviews() {
        return this.offset <= this.maxOffset;
    }

    /**
     * Fetch and process reviews from the server.
     *
     * @returns {$.Deferred}
     */
    getReviews() {
        const numPerPage = isMaxPhone() ? this.pageSizes.SMALL : this.pageSizes.LARGE;

        return $.ajax({
            url: this.reviewsUrl,
            data: {
                num_per_page: numPerPage, // Number of reviews per page
                offset: this.offset, // How many times have we fetched reviews from the server?
            },
        })
            .done((data) => {
                this.processReviews(data.reviews || []);
            })
            .fail((data) => {
                if (data.responseJSON && data.responseJSON.errors.length) {
                    AlerterView.error(data.responseJSON.errors[0].message);
                } else {
                    AlerterView.error();
                }
            });
    }
}

export default ReviewsView;
